import { useAuthContext } from '@/context'
import { imageCreditsEnabledForUser } from '@/lib/imageCreditsAccess'

export function useImageCreditsEnabled(): boolean {
    const { user } = useAuthContext()
    return imageCreditsEnabledForUser(user)
}
